module.exports = __webpack_public_path__ + "static/media/canceled.e28f618a.png";